import type { FlexProps, GridProps, TextProps } from '@chakra-ui/react'
import { Flex, Grid, Text } from '@chakra-ui/react'

import type { RecapTableRowProps } from './RecapTableRow'
import { RecapTableRow } from './RecapTableRow'

export interface RecapTableProps extends GridProps {
  heading?: string
  headingProps?: TextProps
  rows?: RecapTableRowProps[]
  total?: string,
  totalProps?: FlexProps
}

export const RecapTable = ({
  heading,
  headingProps,
  rows,
  total,
  sx,
  totalProps,
  ...rest
}: RecapTableProps) => {

  return (
    <Grid>
      {heading && (
        <Text sx={{ justifySelf: 'end', fontSize: 'sm' }} {...headingProps}>{heading}</Text>
      )}

      <Grid
        sx={{
          gap: 2,
          ...sx,
        }}
        {...rest}
      >
        {rows?.map(({ title, items, ...props }, index) => {
          return <RecapTableRow key={index} title={title} items={items} {...props} />
        })}
      </Grid>

      {total && (
        <Flex
          {...totalProps}
          sx={{
            py: 4,
            alignItems: 'end',
            justifyContent: 'end',
            gap: 8,
            borderBottom: '3px double',
            borderBottomColor: 'neutral.50',
            ...totalProps?.sx
          }}
        >
          <Text sx={{ fontSize: 'sm' }}>Celkem</Text>
          <Text sx={{ fontSize: 'lg', fontWeight: 'bold' }}>{total}</Text>
        </Flex>
      )}
    </Grid>
  )
}
